var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.mostrarDispositivos,
        callback: function($$v) {
          _vm.mostrarDispositivos = $$v
        },
        expression: "mostrarDispositivos"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.formFields.cliente.label,
                          items: _vm.clientes,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.cliente.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.cliente, "value", $$v)
                          },
                          expression: "formFields.cliente.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros mt-1" },
                      [
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.filtroRequerimiento(true)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("search")
                            ]),
                            _vm._v("Filtrar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("AgGridVue", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cerrar Modal")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }